export enum SectionOneSteps {
  EmployerSelection = 0,
  CitizenshipSelection = 1,
  Interpreter = 2,
  EVerify = 3,
  /** Step 1 of the employee document flow — document type selection (List A / B / C) */
  EmpDocTypeSelection = 4,
  /** Step 2 of the employee document flow — document metadata entry */
  EmpDocMetadataEntry = 5,
  Signature = 6,
  Review = 7,
  Confirmation = 8,
  /**
   * Employee correcting only the Section 2 completer they named, reached from their emailed link
   * (`/sectionOne?ct=<token>`). Not part of the forward flow and not in the stepper: it reuses the
   * Section 1 verifier fields so Section 1 itself stays unchanged and needs no re-signing (VTK-1856).
   */
  CompleterEdit = 9,
}

export enum SectionOneStepValue {
  EmployerSelection = 'EmployerSelection',
  CitizenshipSelection = 'CitizenshipSelection',
  Interpreter = 'Interpreter',
  EVerify = 'EVerify',
  EmpDocTypeSelection = 'EmpDocTypeSelection',
  EmpDocMetadataEntry = 'EmpDocMetadataEntry',
  Signature = 'Signature',
  Review = 'Review',
  Confirmation = 'Confirmation',
}
